import {useState, createContext, useContext, useEffect} from 'react';
import Cookies from "js-cookie";
import {postAuthData} from "../api/fetch";

const AuthContext = createContext();

export function AuthProvider({ children }) {
    const [token, setToken] = useState(null);
    const [appUser, setAppUser] = useState(null);
    const [isPending, setIsPending] = useState(true);

    // Retrieve token from cookies on refresh
    useEffect(() => {
        const savedToken = Cookies.get('user_session');
        if (savedToken) {
            setToken(savedToken);
        }

        const savedAppUser = Cookies.get('user_id');
        if (savedAppUser) {
            setAppUser(savedAppUser);
        }

        setIsPending(false);
    }, []);

    const requestLogout = async () => {
        await postAuthData('website/logout', {}, appUser, token, null);

        Cookies.remove('user_session');
        setToken(null);
    }

    const logout = () => {
        requestLogout();
    };

    return (
        <AuthContext.Provider value={{ token, isPending, logout, appUser, isAuthenticated: !!token }}>
            {children}
        </AuthContext.Provider>
    );
}

export const useAuth = () => useContext(AuthContext);